import { t } from 'i18next';
import { StyledLink } from './styles';

export const LIMIT_PAGE = 20;

export const TABLE_COLUMNS = [
  {
    name: 'client',
    value: t('cliente'),
    accessor: 'CLIENT_NAME',
    sortable: false,
  },
  {
    name: 'unit',
    value: t('unidade'),
    accessor: 'UNIT_NAME',
    sortable: false,
    render: (item) => (
      <StyledLink target="_blank" rel="noopener noreferrer" to={`/analise/unidades/${item.UNIT_ID}`}>{item.UNIT_NAME}</StyledLink>
    ),
  },
  {
    name: 'data',
    value: t('data'),
    accessor: 'SMART_CONTROL_ACTION_DATE_AGO',
    sortable: false,
  },
  {
    name: 'hora',
    value: t('hora'),
    accessor: 'HOUR_ACTION',
    sortable: false,
  },
  {
    name: 'user',
    value: t('usuario'),
    accessor: 'USER_ID',
    sortable: false,
  },
  {
    name: 'environment',
    value: t('ambiente'),
    accessor: 'ENVIRONMENT_NAME',
    sortable: false,
    render: (item) => (
      <StyledLink target="_blank" rel="noopener noreferrer" to={`/analise/dispositivo/${item.DEV_AUT}/historico?data=${encodeURIComponent(item.SMART_CONTROL_ACTION_DATE_AGO)}`}>{item.ENVIRONMENT_NAME}</StyledLink>
    ),
  },
  {
    name: 'machine',
    value: t('maquina'),
    accessor: 'MACHINE_NAME',
    sortable: false,
    render: (item) => (
      <StyledLink target="_blank" rel="noopener noreferrer" to={`/analise/maquina/${item.MACHINE_ID}/ativos/${item.DEV_AUT}/informacoes`}>{item.MACHINE_NAME}</StyledLink>
    ),
  },
  {
    name: 'reason',
    value: t('motivo'),
    accessor: 'REASON',
    sortable: false,
  },
  {
    name: 'change',
    value: t('alteracao'),
    accessor: 'FORMATTED_CURRENT_PROGRAMMING',
    sortable: false,
    render: (item) => (
      <div style={{ wordBreak: 'break-word' }}>
        {item.FORMATTED_CURRENT_PROGRAMMING}
      </div>
    ),
  },
  {
    name: 'progAnt',
    value: t('programacaoAnterior'),
    accessor: 'FORMATTED_BEFORE_PROGRAMMING',
    sortable: false,
    render: (item) => (
      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {item.FORMATTED_BEFORE_PROGRAMMING}
      </div>
    ),
  },
  {
    name: 'manualMode',
    value: t('modoEconomia'),
    accessor: 'ECONOMY_MODE_STATUS',
  },
];

export const TRANSLATE_REASONS = {
  COLD: t('sensacaoFrio'),
  HOT: t('sensacaoCalor'),
  MAINTENANCE: t('manutencao'),
  OUT_SCHEDULE: t('foraProgramacao'),
  OTHER: t('outro'),
};

export const OPTIONS_ECONOMY_MODE = [
  { name: t('ativado'), value: 'ECONOMY_MODE_OFF' },
  { name: t('desativado'), value: 'ECONOMY_MODE_ON' },
];

export const OPTIONS_CHANGE = [
  { name: t('ligadoMin'), value: 'ECONOMY_MODE_ON' },
  { name: t('desligadoMin'), value: 'ECONOMY_MODE_OFF' },
];
